// Registrars + Route Builder
import { LayoutRegistration } from 'json-react-layouts'

import {
    ComponentRendererErrorRegistration,
    FailLoadContentRegistration,
    FailLoadContent404Registration,
    NovemberRegistration,
    AdUnitRegistration,
    AmpStickyAdUnitRegistration,
    InlineContentRegistration,
    StaticContentRegistration,
    SectionHeaderRegistration,
    BreadcrumbRegistration,
    IframeRegistration,
    ProfileRegistration,
    TheWestPageNotFoundRegistration,
    TheWestSomethingWentWrongRegistration,
    NewsletterSignupRegistration,
    LinkBannerRegistration,
    PromotionalCardRegistration,
    QuickLinksRegistration,
    TelethonCountdownRegistration,
    TaboolaRegistration,
    RippleRegistration,
    TheWestLiveBillboardRegistration,
    ContentSeparatorRegistration,
    HorizontalCricketWidgetRegistration,
    TheWestLivePlayerPageRegistration,
    CookieConsentUserSettingsPageRegistration,
    ZeusRegistration,
    ThorRegistration,
    BoxRegistration,
    CerberusRegistration,
    JanusRegistration,
    LiveScoresRegistration,
    JulietRegistration,
    LimaRegistration,
    OscarRegistration,
    ParagraphRegistration,
    SierraRegistration,
    UniformRegistration,
    WhiskeyRegistration,
    TheWestArticleRegistration,
    TheWestFeatureRegistration,
    TheWestGalleryRegistration,
    BreakingNewsRegistration,
    SearchRegistration,
    ImageBannerRegistration,
    ProfileCardRegistration,
    ArticleHeroRegistration,
    SharingRegistration,
    FeatureHeadlineRegistration,
    FigCaptionRegistration,
    TopicListRegistration,
    OmnyRegistration,
    RelatedContentRegistration,
    PublicationRelatedContentRegistration,
    CoralRegistration,
    TheWestTermsContentRegistration,
    PaperPromoRegistration,
    AthenaRegistration,
    CerberusFourRegistration,
    FeatureArticleBreachCompositionRegistration,
    FeatureCompositionRegistration,
    StaticSubscribePromoCardRegistration,
    TWStaticAFLCardRegistration,
    OurPublicationRegistration,
    NewsletterSubscriptionRegistration,
} from '@news-mono/component-library'
import {
    ComponentServices,
    componentFeatureToggleMiddleware,
    dataLoaderMiddleware,
    componentOnEventMiddleware,
} from '@news-mono/web-common'

import { RSSFeedsRegistration } from './routes/static/RSS/RSS.routing'

// Register Components & Collections
export const layout = LayoutRegistration<ComponentServices>()
    .registerComponents((registrar) =>
        registrar
            .registerComponent(ComponentRendererErrorRegistration)
            .registerComponent(FailLoadContentRegistration)
            .registerComponent(FailLoadContent404Registration)

            // collections
            .registerComponent(JulietRegistration)
            .registerComponent(LimaRegistration)
            .registerComponent(SierraRegistration)
            .registerComponent(UniformRegistration)
            .registerComponent(OscarRegistration)
            .registerComponent(NovemberRegistration)
            .registerComponent(WhiskeyRegistration)

            // components
            .registerComponent(AdUnitRegistration)
            .registerComponent(AmpStickyAdUnitRegistration)
            .registerComponent(InlineContentRegistration)
            .registerComponent(TheWestArticleRegistration)
            .registerComponent(TheWestGalleryRegistration)
            .registerComponent(TheWestFeatureRegistration)
            .registerComponent(StaticContentRegistration)
            .registerComponent(SectionHeaderRegistration)
            .registerComponent(BreakingNewsRegistration)
            .registerComponent(BreadcrumbRegistration)
            .registerComponent(SearchRegistration)
            .registerComponent(IframeRegistration)
            .registerComponent(ProfileRegistration)
            .registerComponent(TheWestPageNotFoundRegistration)
            .registerComponent(TheWestSomethingWentWrongRegistration)
            .registerComponent(LiveScoresRegistration)
            .registerComponent(NewsletterSignupRegistration)
            .registerComponent(LinkBannerRegistration)
            .registerComponent(ImageBannerRegistration)
            .registerComponent(PromotionalCardRegistration)
            .registerComponent(ProfileCardRegistration)
            .registerComponent(ArticleHeroRegistration)
            .registerComponent(SharingRegistration)
            .registerComponent(FeatureHeadlineRegistration)
            .registerComponent(FigCaptionRegistration)
            .registerComponent(TopicListRegistration)
            .registerComponent(QuickLinksRegistration)
            .registerComponent(TelethonCountdownRegistration)
            .registerComponent(OmnyRegistration)
            .registerComponent(RelatedContentRegistration)
            .registerComponent(ParagraphRegistration)
            .registerComponent(TaboolaRegistration)
            .registerComponent(RippleRegistration)
            .registerComponent(TheWestLiveBillboardRegistration)
            .registerComponent(PublicationRelatedContentRegistration)
            .registerComponent(ContentSeparatorRegistration)
            .registerComponent(CoralRegistration)
            .registerComponent(TheWestTermsContentRegistration)
            .registerComponent(PaperPromoRegistration)

            // internal west components
            .registerComponent(RSSFeedsRegistration)
            .registerComponent(HorizontalCricketWidgetRegistration)
            .registerComponent(StaticSubscribePromoCardRegistration)
            .registerComponent(TWStaticAFLCardRegistration)
            .registerComponent(OurPublicationRegistration)
            .registerComponent(TheWestLivePlayerPageRegistration)
            .registerComponent(CookieConsentUserSettingsPageRegistration)
            .registerComponent(NewsletterSubscriptionRegistration)

            .registerMiddleware(componentFeatureToggleMiddleware)
            .registerMiddleware(dataLoaderMiddleware)
            .registerMiddleware(componentOnEventMiddleware),
    )
    .registerCompositions((registrar) =>
        registrar
            .registerComposition(AthenaRegistration)
            .registerComposition(ZeusRegistration)
            .registerComposition(ThorRegistration)
            .registerComposition(BoxRegistration)
            .registerComposition(CerberusRegistration)
            .registerComposition(CerberusFourRegistration)
            .registerComposition(JanusRegistration)
            .registerComposition(FeatureCompositionRegistration)
            .registerComposition(FeatureArticleBreachCompositionRegistration)
            .registerMiddleware(componentFeatureToggleMiddleware),
    )
